<template>
  <h3 class="text-center font-semibold text-gray-700">Calibres</h3>
  <div id="chart1">
    <apexchart
      type="bar"
      :options="options"
      :series="series"
      height="350"
      width="100%"
    />
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";

export default {
  name: "PRODReportingProcessShowReportsGraphicsCropSizes",
  components: {
    apexchart: VueApexCharts
  },
  props: { data: { required: true } },
  data() {
    return {
      series: [
        {
          data: Object.values(this.data)
        }
      ],
      options: {
        chart: {
          type: "bar"
        },
        plotOptions: {
          bar: {
            columnWidth: "45%",
            distributed: true,
            borderRadius: 4
          }
        },
        dataLabels: {
          enabled: false,
          style: {
            fontSize: "16px"
          },
          formatter: function (val) {
            return this.numberWithPrecision(val);
          }.bind(this)
        },
        legend: {
          show: false
        },
        tooltip: {
          enabled: true,
          style: { fontSize: "16px" },
          y: {
            formatter: function (val) {
              return this.numberWithPrecision(val);
            }.bind(this),
            title: {
              formatter: function () {
                return "";
              }.bind(this)
            }
          }
        },
        xaxis: {
          categories: Object.keys(this.data),
          labels: {
            style: { fontSize: "12px" }
          }
        },
        yaxis: {
          title: {
            text: "Kilogramos"
          },
          labels: {
            formatter: function (val) {
              return this.numberWithPrecision(val);
            }.bind(this)
          }
        },
        colors: [
          "#ef4444",
          "#f97316",
          "#84cc16",
          "#10b981",
          "#3b82f6",
          "#a855f7",
          "#f43f5e",
          "#eab308"
        ]
      }
    };
  }
};
</script>
